'use client';

import SafeImage from '@ui/SafeImage';
import { getCDNUrl } from '@util/index';
import { useAnimationControls } from 'framer-motion';
import { MotionDiv, MotionSpan } from 'motion';
import Link from 'next/link';
import React from 'react';

const NavMenu = ({
  label,
  displayLabel,
  href,
  image,
  disableTopLevelLink,
  onHover,
  onLinkClick,
}: {
  label: string;
  displayLabel: string;
  href: string;
  image?: string;
  disableTopLevelLink?: boolean;
  onHover: () => void;
  onLinkClick?: () => void;
}) => {
  const controls = useAnimationControls();

  const handleTopLevelClick = (e: React.MouseEvent) => {
    if (disableTopLevelLink) {
      e.preventDefault();
      return;
    }
    onLinkClick?.();
  };

  return (
    <button
      type="button"
      className="group flex w-max items-center transition-all duration-300 ease-linear hover:mx-4 hover:gap-x-4 hover:bg-brand-darker-white"
      onMouseEnter={() => {
        onHover();
        controls.start({ opacity: 1, paddingRight: 1 });
      }}
      onMouseLeave={() => {
        controls.start({ opacity: 0, paddingRight: 0 });
      }}
    >
      <Link
        href={href}
        className="flex h-full items-center text-[1.4rem]"
        onClick={handleTopLevelClick}
      >
        <MotionDiv
          className="h-16 w-auto overflow-hidden"
          initial={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          animate={controls}
        >
          <SafeImage
            src={getCDNUrl(image ?? '')}
            alt={label.toLowerCase() + ' navigation image'}
            className={`h-0 w-0 object-cover opacity-0 transition-all duration-300 ease-in-out group-hover:h-full group-hover:w-16 group-hover:opacity-100 ${
              label === 'Snow' ? '' : 'object-right'
            } ${label === 'PWC' ? 'scale-[1.7]' : ''}`}
          />
        </MotionDiv>

        <MotionSpan className="transition-all duration-150 ease-linear group-hover:pl-3 group-hover:pr-5">
          {displayLabel}
        </MotionSpan>
      </Link>
    </button>
  );
};

export default NavMenu;
